/* Product page concept X: gallery, size choice, the mix card (2 or 3 scents, a size per scent), gift ladder (free
   gifts by order amount), add to bag, sticky bar, comparison popover, video cards and the delivery timeline. */
(() => {
  const root = document.querySelector('[data-pdpx]');
  if (!root) return;
  const $ = (s, r = root) => r.querySelector(s);
  const $$ = (s, r = root) => [...r.querySelectorAll(s)];
  const money = (c) => (window.Scentzi && window.Scentzi.money ? window.Scentzi.money(c) : `€ ${(c / 100).toFixed(2).replace('.', ',')}`);
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const goal = +root.dataset.goal || 6000;
  let cartTotal = +root.dataset.cartTotal || 0;
  const variantInput = $('[data-pdpx-variant]');
  const sizeOf = (sku) => +(String(sku || '').split('-').pop()) || 0;

  /* ---------- gallery ---------- */
  const slides = $('[data-slides]');
  const thumbs = $$('[data-thumb]');
  const dots = $$('.pdpx-dots i');
  // A refill or sample photo that is not in the gallery covers the frame while that size is chosen; any
  // gallery navigation (thumb, arrow, swipe) or another size takes it away again.
  const shot = $('[data-shot]');
  const showShot = (src) => { if (!shot) return; $('[data-shot-img]', shot).src = src; shot.hidden = false; };
  const hideShot = () => { if (shot) shot.hidden = true; };
  let shownAt = -1; // slide that was in view when the size photo appeared
  const goTo = (i) => {
    hideShot();
    const slide = $(`[data-slide="${i}"]`);
    if (slide) slides.scrollTo({ left: slide.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
  };
  thumbs.forEach((t) => t.addEventListener('click', () => goTo(t.dataset.thumb)));
  $$('[data-step]').forEach((btn) => btn.addEventListener('click', () => {
    const count = $$('[data-slide]').length;
    const i = Math.round(slides.scrollLeft / slides.clientWidth);
    goTo((i + +btn.dataset.step + count) % count);
  }));
  if (slides) {
    let frame = 0;
    slides.addEventListener('scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const i = Math.round(slides.scrollLeft / slides.clientWidth);
        if (i !== shownAt) hideShot();
        thumbs.forEach((t, n) => t.setAttribute('aria-pressed', n === i));
        dots.forEach((d, n) => d.classList.toggle('on', n === i));
      });
    }, { passive: true });
  }
  // "Volledige beschrijving" / "Geurnoten" / guarantee open their accordion and bring it into view.
  $$('[data-open]').forEach((a) => a.addEventListener('click', (e) => {
    const d = document.getElementById(a.dataset.open);
    if (!d) return;
    e.preventDefault();
    d.open = true;
    d.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
  }));

  /* ---------- catalogue for the scent and sample pickers (public collection JSON, loaded once) ---------- */
  let catalogue = null, loading = null;
  const loadCatalogue = () => {
    if (catalogue) return Promise.resolve(catalogue);
    if (!loading) {
      loading = fetch('/collections/parfum/products.json?limit=250')
        .then((r) => r.json())
        .then((d) => refsReady.then(() => d))
        .then((d) => {
          catalogue = (d.products || []).map((p) => ({
            handle: p.handle,
            name: p.title.replace(/^Olfazeta\s+/, '').replace(/^Cooperativa Profumieri\s+/, ''),
            tags: p.tags || [],
            variants: p.variants.map((v) => ({ id: v.id, ml: sizeOf(v.sku), price: Math.round(parseFloat(v.price) * 100), available: v.available })),
          })).sort((a, b) => a.name.localeCompare(b.name, 'nl'));
          fillPickers();
          return catalogue;
        })
        .catch(() => { loading = null; return []; });
    }
    return loading;
  };
  // What each scent is inspired by ({handle: [name, brand]}, tools/build-references.py): a name like
  // "Enigma" tells a shopper nothing, "Paradoxe van Prada" does. Care products share the perfume's number.
  let refs = {};
  const refsReady = fetch(root.dataset.refs).then((r) => r.json()).then((d) => { refs = d; }).catch(() => {});
  const refOf = (handle) => refs[handle] || refs[handle.replace(/^olfazeta-(?:crf|bsf)0*(\d+)$/, 'olfazeta-$1')];
  const refText = (r) => (r[1] ? `${r[0]} van ${r[1]}` : r[0]);
  const caption = (sel) => {
    const cap = sel.parentElement.querySelector('[data-ref-cap]');
    const ref = sel.selectedOptions[0] && sel.selectedOptions[0].dataset.ref;
    if (cap) cap.textContent = ref ? `Geïnspireerd door ${ref}` : '';
  };
  // Options grouped by the brand of the reference perfume, sorted on the reference name.
  function addGrouped(sel, list, label, value) {
    const groups = new Map();
    list.forEach((p) => {
      const r = refOf(p.handle);
      const key = r && r[1] ? r[1] : 'Overige geuren';
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push({ p, r });
    });
    [...groups.keys()].sort((a, b) => (a === 'Overige geuren') - (b === 'Overige geuren') || a.localeCompare(b, 'nl')).forEach((key) => {
      const group = document.createElement('optgroup');
      group.label = key;
      groups.get(key).sort((a, b) => (a.r ? a.r[0] : a.p.name).localeCompare(b.r ? b.r[0] : b.p.name, 'nl')).forEach(({ p, r }) => {
        const option = new Option(label(p, r), value(p));
        if (r) option.dataset.ref = refText(r);
        group.append(option);
      });
      sel.append(group);
    });
  }
  const scentLabel = (p, r) => (r ? `${p.name} · ${r[0]}` : p.name);
  function fillPickers() {
    if (!catalogue) return;
    const self = root.dataset.handle;
    $$('[data-mix-slot]').forEach((sel) => {
      if (sel.options.length > 1) return;
      addGrouped(sel, catalogue.filter((p) => p.handle !== self && p.variants.some((v) => v.available)), scentLabel, (p) => p.handle);
    });
    $$('[data-pick="1"]').forEach((sel) => {
      if (sel.options.length > 1) return;
      addGrouped(sel, catalogue.filter((p) => p.variants.some((v) => v.ml === 3)), scentLabel, (p) => p.name);
    });
  }
  let careLoaded = null;
  const loadCare = () => {
    if (careLoaded) return careLoaded;
    careLoaded = fetch('/collections/verzorging/products.json?limit=250').then((r) => r.json()).then((d) => refsReady.then(() => d)).then((d) => {
      const care = (d.products || []).map((p) => ({ handle: p.handle, name: p.title.replace(/^Olfazeta\s+/, '') }))
        .filter((p) => /^(Douchegel|Bodycr)/i.test(p.name));
      $$('[data-pick="2"]').forEach((sel) => addGrouped(sel, care, (p, r) => (r ? `${p.name.split(' ')[0]} · ${r[0]}` : p.name), (p) => p.name));
    }).catch(() => { careLoaded = null; });
    return careLoaded;
  };

  /* ---------- choice ---------- */
  const sizeRadio = () => $('.pdpx-size input:checked');
  const current = () => {
    const r = sizeRadio();
    return r ? { id: +r.dataset.variant, price: +r.dataset.price, ml: +r.dataset.ml } : { id: +variantInput.value, price: +variantInput.dataset.price || 0, ml: 0 };
  };
  // Mix card: every row is a scent plus its size (a 70 ml can go with a 30 ml); the size options are the scent's own.
  const setBox = $('[data-pdpx-set]');
  const selfVariants = $$('.pdpx-size input').map((r) => ({ id: +r.dataset.variant, price: +r.dataset.price, ml: +r.dataset.ml, available: !r.disabled }));
  let setCount = 2;
  const setOpen = () => !!setBox && !$('.pdpx-set-body').hidden;
  const setN = () => setCount;
  const setVariant = (n) => {
    const sel = $(`[data-set-size="${n}"]`);
    const o = sel && sel.selectedOptions[0];
    return o ? { id: +o.value, price: +o.dataset.price, ml: +o.dataset.ml } : null;
  };
  const setLines = (n = setN()) => { const out = []; for (let i = 1; i <= n; i += 1) { const v = setVariant(i); if (v) out.push(v); } return out; };
  const sum = (lines) => lines.reduce((t, v) => t + v.price, 0);
  function fillSizes(n) {
    const sel = $(`[data-set-size="${n}"]`);
    const scent = $(`[data-mix-slot="${n}"]`);
    const p = scent && scent.value && catalogue ? catalogue.find((x) => x.handle === scent.value) : null;
    const list = (p ? p.variants : selfVariants).filter((v) => v.available && v.ml > 3).sort((a, b) => b.ml - a.ml);
    const was = sel.selectedOptions[0] ? +sel.selectedOptions[0].dataset.ml : 0;
    sel.replaceChildren(...list.map((v) => {
      const o = new Option(`${v.ml} ml · ${money(v.price)}`, v.id, false, v.ml === was);
      o.dataset.price = v.price;
      o.dataset.ml = v.ml;
      return o;
    }));
    sel.disabled = list.length < 2;
  }
  // What is being added right now: the open mix card, else the chosen bottle.
  const etuiBox = $('[data-etui]');
  const etuiAnchor = document.createComment('etui');
  if (etuiBox) etuiBox.before(etuiAnchor);
  const etuiPick = () => {
    const r = etuiBox && !etuiBox.hidden && $('input[name="pdpx-etui"]:checked', etuiBox);
    return r && r.value ? { id: +r.value, price: +r.dataset.price, ml: 0 } : null;
  };
  const withEtui = (lines) => { const e = etuiPick(); return e ? [...lines, e] : lines; };
  const pending = () => withEtui(setOpen() ? setLines() : [current()]);
  // A 15 ml refill needs an etui: show the choice where the buying happens (under the sizes, or inside the open mix).
  function placeEtui() {
    if (!etuiBox) return;
    const mixing = setOpen();
    const refill = (mixing ? setLines() : [current()]).some((v) => v.ml === 15);
    if (!refill) { const none = $('input[name="pdpx-etui"][value=""]', etuiBox); if (none) none.checked = true; }
    etuiBox.hidden = !refill;
    if (mixing && !$('.pdpx-set-body').contains(etuiBox)) $('[data-set-buy]').before(etuiBox);
    if (!mixing && etuiAnchor.nextSibling !== etuiBox) etuiAnchor.after(etuiBox);
    const e = etuiPick(), chosen = $('[data-etui-chosen]', etuiBox);
    if (chosen) { chosen.hidden = !e; if (e) chosen.textContent = `${$('input[name="pdpx-etui"]:checked', etuiBox).dataset.name} gaat mee in je winkelmand (+${money(e.price)}).`; }
  }
  // When shipping and the samples share one amount, the first name already says "en 3 samples": skip tier 1 then.
  const giftText = (got) => {
    const t = tierNames.slice(0, got).filter((_, i) => !(i === 1 && tiers[0] === tiers[1])).join(' + ');
    return t.charAt(0).toUpperCase() + t.slice(1);
  };
  // Distance to the next gift for the open set and up to three concrete ways to reach it, cheapest first, none that
  // overshoots by more than EUR 25: bigger sizes (every size combination), a small third bottle, or another scent in a
  // row that costs just enough more, preferring scents like the chosen one (same audience, family, reference brand).
  const FAMILIES = ['fris', 'citrus', 'aquatisch', 'bloemig', 'fruitig', 'zoet', 'gourmand', 'poederig', 'amber', 'houtachtig', 'kruidig', 'leer', 'musk'];
  const audience = (tags) => ['dames', 'heren', 'unisex'].find((g) => tags.includes(g));
  function likeness(p, base) {
    if (!base) return 0;
    const a = audience(p.tags), b = audience(base.tags);
    if (a && b && a !== b && a !== 'unisex' && b !== 'unisex') return -1;
    const ra = refOf(p.handle), rb = refOf(base.handle);
    return FAMILIES.filter((f) => p.tags.includes(f) && base.tags.includes(f)).length + (ra && rb && ra[1] && ra[1] === rb[1] ? 2 : 0);
  }
  function setFix() {
    const lines = setLines();
    const amount = cartTotal + sum(lines);
    const next = tiers.find((t) => amount < t);
    if (!next) return { done: true };
    const gap = next - amount;
    const fits = (extra) => extra >= gap && extra - gap <= 2500;
    const options = [];
    // bigger sizes
    const rows = lines.map((v, i) => [...$(`[data-set-size="${i + 1}"]`).options].map((o) => ({ value: o.value, ml: +o.dataset.ml, extra: +o.dataset.price - v.price })));
    let best = null;
    const walk = (i, extra, changes) => {
      if (i === rows.length) {
        if (changes.length && fits(extra) && (!best || extra < best.extra || (extra === best.extra && changes.length < best.changes.length))) best = { extra, changes };
        return;
      }
      rows[i].forEach((o) => walk(i + 1, extra + o.extra, o.extra ? [...changes, { row: i + 1, value: o.value, ml: o.ml }] : changes));
    };
    walk(0, 0, []);
    if (best) {
      const c = best.changes;
      const label = c.length === 1 ? `Maak geur ${c[0].row} een ${c[0].ml} ml`
        : c.every((x) => x.ml === c[0].ml) ? `Maak geur ${c.map((x) => x.row).join(' en ')} een ${c[0].ml} ml`
          : `Maak ${c.map((x) => `geur ${x.row} een ${x.ml} ml`).join(' en ')}`;
      options.push({ extra: best.extra, label, apply: () => c.forEach((x) => { $(`[data-set-size="${x.row}"]`).value = x.value; }) });
    }
    // a small third bottle (of the scent in row 3, by default this one)
    if (setN() === 2) {
      const sel = $('[data-set-size="3"]');
      const o = [...sel.options].filter((x) => fits(+x.dataset.price)).sort((a, b) => a.dataset.price - b.dataset.price)[0];
      if (o) options.push({ extra: +o.dataset.price, label: `Voeg een 3e fles van ${o.dataset.ml} ml toe`, apply: () => { setCount = 3; sel.value = o.value; } });
    }
    // another scent in row 2 or 3
    if (catalogue) {
      const base = catalogue.find((x) => x.handle === root.dataset.handle);
      const swaps = [];
      lines.forEach((v, i) => {
        const row = i + 1;
        if (row === 1) return;
        const scent = $(`[data-mix-slot="${row}"]`);
        catalogue.forEach((p) => {
          if (p.handle === root.dataset.handle || p.handle === scent.value) return; // another scent, not this one again
          const score = likeness(p, base);
          if (score < 0) return;
          p.variants.filter((x) => x.available && x.ml > 3 && fits(x.price - v.price)).forEach((x) => swaps.push({ p, x, row, score, extra: x.price - v.price }));
        });
      });
      swaps.sort((a, b) => b.score - a.score || a.extra - b.extra);
      const seen = new Set();
      swaps.filter((w) => !seen.has(w.p.handle) && seen.add(w.p.handle)).slice(0, 2).forEach((w) => {
        const r = refOf(w.p.handle);
        options.push({
          extra: w.extra,
          label: `Kies ${w.p.name}${r ? ` (geïnspireerd door ${r[0]})` : ''} als geur ${w.row}, ${w.x.ml} ml`,
          apply: () => {
            const sel = $(`[data-mix-slot="${w.row}"]`);
            sel.value = w.p.handle;
            fillSizes(w.row);
            $(`[data-set-size="${w.row}"]`).value = w.x.id;
            caption(sel);
          },
        });
      });
    }
    options.sort((a, b) => a.extra - b.extra);
    return { gap, name: tierNames[tiers.indexOf(next)], options: options.slice(0, 3) };
  }
  // Gift ladder: tier amounts in cents (free shipping, 3 samples, douchegel/bodycreme). Shipping and the samples
  // share one amount, so the first step reads as one. A tier counts as in the bag once the bag holds as many of
  // its gift product as the tiers up to it use (so one product could serve two tiers).
  const tiers = (root.dataset.tiers || '7000,7000,11500').split(',').map(Number);
  const tierNames = [tiers[0] === tiers[1] ? 'gratis verzending en 3 samples' : 'gratis verzending', '3 samples', 'douchegel of bodycrème'];
  const comboGifts = ['gratis verzending', '3 gratis samples', 'een gratis douchegel of bodycrème'];
  const ladder = $('[data-pdpx-ladder]');
  const giftIds = ladder ? [null, +ladder.dataset.giftSamples, +ladder.dataset.giftCare] : [];
  let inCart = new Map(); // gift variant -> quantity already in the bag
  const has = (i) => !!giftIds[i] && (inCart.get(giftIds[i]) || 0) >= giftIds.slice(0, i + 1).filter((id) => id === giftIds[i]).length;
  const reached = (amount) => tiers.filter((t) => amount >= t).length; // number of tiers unlocked

  function render() {
    placeEtui();
    const total = current().price;
    // One choice drives every buy button (main, mix card, sticky bar): the open mix, else the chosen bottle.
    const mixing = setOpen();
    $$('[data-pdpx-total]', document).forEach((el) => { el.textContent = money(sum(pending())); });
    $$('[data-cta-label]', document).forEach((el) => { el.textContent = mixing ? 'Mix in winkelmand' : 'In winkelmand'; });
    const barLabel = $('[data-pdpx-bar-label]', document), chosen = sizeRadio();
    if (barLabel) barLabel.textContent = mixing ? `Mix van ${setN()} geuren` : (chosen ? chosen.dataset.title : barLabel.textContent);
    if (setBox) {
      const n = setN(), open = setOpen();
      $$('[data-set-row]').forEach((row) => { row.hidden = +row.dataset.setRow > n; });
      $$('[data-set-pick]').forEach((tile) => {
        const k = +tile.dataset.setPick, t = sum(setLines(k)), got = reached(cartTotal + t);
        const next = tiers.find((x) => cartTotal + t < x);
        tile.querySelector('[data-set-price]').textContent = money(t);
        tile.querySelector('[data-set-gifts]').innerHTML = got
          ? `<b>✓ ${giftText(got)}</b>`
          : `Nog ${money(next - cartTotal - t)} tot ${tierNames[0]}`;
        tile.classList.toggle('selected', open && k === n);
        tile.setAttribute('aria-expanded', open && k === n);
      });
      $('[data-set-total]').textContent = money(sum(withEtui(setLines())));
      const nudge = $('[data-set-nudge]'), f = open ? setFix() : null;
      nudge.hidden = !f;
      if (f && f.done) nudge.innerHTML = '<b>Alle cadeaus zitten erbij.</b>';
      else if (f) {
        nudge.innerHTML = `${f.gap <= 2500 ? 'Bijna! ' : ''}Nog <b>${money(f.gap)}</b> tot ${f.name === tierNames[0] ? f.name : `je gratis ${f.name}`}.${f.options.length ? ' Zo haal je het:' : ''}`;
        if (f.options.length) {
          const list = document.createElement('div');
          list.className = 'pdpx-set-options';
          f.options.forEach((o) => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.innerHTML = `<span></span><b>+${money(o.extra)}</b>`;
            btn.firstChild.textContent = o.label;
            btn.addEventListener('click', () => { o.apply(); render(); });
            list.append(btn);
          });
          nudge.append(list);
        }
      }
    }
    // Combi card follows the order: far from the free care gift -> buy the pair; almost there -> the ways to get it
    // free; reached -> no buy button, but pick this care product as the free gift.
    const amount = cartTotal + sum(pending());
    const careTier = tiers[2], careInCart = has(2), careGot = careInCart || amount >= careTier;
    const carePick = $('[data-pick="2"]');
    const optionButton = (label, extra, apply) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.innerHTML = `<span></span>${extra ? `<b>+${money(extra)}</b>` : ''}`;
      b.firstChild.textContent = label;
      b.addEventListener('click', apply);
      return b;
    };
    $$('[data-combo-card]').forEach((card) => {
      const btn = card.querySelector('[data-combo]'), note = card.querySelector('[data-combo-note]'), box = card.querySelector('[data-combo-extra]');
      const care = card.dataset.careName;
      box.replaceChildren();
      btn.hidden = careGot;
      if (careInCart) { note.textContent = '✓ Je gratis douchegel of bodycrème zit al in je winkelmand.'; return; }
      if (careGot) {
        const chosen = carePick && carePick.value === care;
        note.textContent = chosen ? `✓ ${care} is je gratis cadeau.` : '✓ Je krijgt een douchegel of bodycrème gratis.';
        if (!chosen && carePick) box.append(optionButton(`Kies ${care} als gratis cadeau`, 0, () => loadCare().then(() => { carePick.value = care; caption(carePick); render(); })));
        return;
      }
      const f = setOpen() && careTier - amount <= 2500 ? setFix() : null;
      if (f && f.options && f.name === tierNames[2]) {
        btn.hidden = true;
        note.innerHTML = `Bijna! Nog <b>${money(f.gap)}</b> en je krijgt ${care} gratis.${f.options.length ? ' Vul je mix aan:' : ''}`;
        f.options.forEach((o) => box.append(optionButton(o.label, o.extra, () => { o.apply(); render(); })));
        return;
      }
      const pair = sum(pending()) + +btn.dataset.price;
      btn.querySelector('[data-combo-total]').textContent = money(pair);
      const extra = comboGifts.slice(reached(amount), reached(cartTotal + pair));
      note.textContent = extra.length ? `Samen ${money(pair)}: ${extra.join(' en ')} erbij` : '';
    });
    // gift ladder
    if (ladder) {
      const amount = cartTotal + sum(pending());
      const got = reached(amount);
      const next = tiers.find((t) => amount < t);
      $('[data-ladder-msg]').innerHTML = next
        ? `Nog <b>${money(next - amount)}</b> tot ${next === tiers[0] ? tierNames[0] : `je gratis ${tierNames[tiers.indexOf(next)]}`}`
        : '<b>Al je cadeaus zijn ontgrendeld!</b>';
      const top = tiers[tiers.length - 1];
      $('[data-ladder-fill]').style.width = `${Math.max(3, Math.min(100, (amount / top) * 100))}%`;
      $$('[data-tier]').forEach((li) => {
        const i = +li.dataset.tier;
        li.classList.toggle('unlocked', i < got);
        li.classList.toggle('in-cart', has(i));
      });
      let anyPick = false;
      $$('[data-pick-group]').forEach((g) => {
        const i = +g.dataset.pickGroup;
        const show = i < got && !has(i);
        g.hidden = !show;
        anyPick = anyPick || show;
      });
      $('[data-ladder-picks]').hidden = !anyPick;
      if (anyPick) { loadCatalogue(); if (got >= 3) loadCare(); }
    }
  }

  function selectSize(radio) {
    if (!radio || radio.disabled) return;
    if (setOpen()) $('.pdpx-set-body').hidden = true; // picking one bottle closes the mix
    radio.checked = true;
    $$('.pdpx-size').forEach((l) => l.classList.toggle('selected', l.contains(radio)));
    variantInput.value = radio.dataset.variant;
    $('[data-pdpx-price]').textContent = money(+radio.dataset.price);
    const ml = $('[data-pdpx-ml]');
    if (ml && +radio.dataset.ml) ml.textContent = `${money(Math.floor(+radio.dataset.price / +radio.dataset.ml))} per ml`;
    const label = $('[data-pdpx-bar-label]', document);
    if (label) label.textContent = radio.dataset.title;
    const seal = $('[data-pdpx-sample]');
    if (seal) seal.hidden = seal.dataset.pdpxSample === radio.dataset.variant;
    if (radio.dataset.shot) {
      showShot(radio.dataset.shot);
      if (slides) shownAt = Math.round(slides.scrollLeft / slides.clientWidth);
    } else if (radio.dataset.media) {
      const slide = $$('[data-media-src]').find((s) => s.dataset.mediaSrc === radio.dataset.media);
      if (slide) goTo(slide.dataset.slide); else hideShot();
    } else hideShot();
    const url = new URL(location.href); url.searchParams.set('variant', radio.dataset.variant);
    history.replaceState(null, '', url);
    render();
  }
  $$('.pdpx-size input').forEach((r) => r.addEventListener('change', () => selectSize(r)));
  if (setBox) {
    // A deal row opens the builder with that many scents; tapping the open one closes it again.
    $$('[data-set-pick]').forEach((tile) => tile.addEventListener('click', () => {
      const k = +tile.dataset.setPick, body = $('.pdpx-set-body');
      body.hidden = !body.hidden && setCount === k;
      setCount = k;
      if (!body.hidden) loadCatalogue();
      render();
    }));
    $$('[data-mix-slot]').forEach((sel) => sel.addEventListener('change', () => { fillSizes(+sel.dataset.mixSlot); render(); }));
    $$('[data-set-size]').forEach((sel) => sel.addEventListener('change', render));
    $('[data-set-buy]').addEventListener('click', (e) => add(e.currentTarget, withEtui(setLines())));
  }
  $$('.pdpx-set-row select:first-of-type, .pdpx-mix-row select').forEach((sel) => { caption(sel); sel.addEventListener('change', () => caption(sel)); });
  // Comparison popover: closes on a click outside it or on Escape.
  const compare = $('[data-compare]');
  if (compare) {
    document.addEventListener('click', (e) => { if (compare.open && !compare.contains(e.target)) compare.open = false; });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && compare.open) { compare.open = false; compare.querySelector('summary').focus(); } });
  }
  $$('[data-combo]').forEach((btn) => btn.addEventListener('click', () => add(btn, [...pending(), { id: +btn.dataset.combo, price: +btn.dataset.price }])));
  $$('[data-pick="2"]').forEach((sel) => sel.addEventListener('change', render));
  $$('input[name="pdpx-etui"]').forEach((r) => r.addEventListener('change', render));
  const seal = $('[data-pdpx-sample]');
  if (seal) seal.addEventListener('click', () => {
    selectSize($(`.pdpx-size input[data-variant="${seal.dataset.pdpxSample}"]`));
    $('#pdpx-kiezen').scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- add to bag: the bottle or the mix (same variants merged) and the gifts the amount unlocks ---------- */
  function items(lines) {
    const list = new Map();
    lines.forEach((v) => list.set(v.id, (list.get(v.id) || 0) + 1));
    const out = [...list].map(([id, quantity]) => ({ id, quantity }));
    if (ladder) {
      const got = reached(cartTotal + sum(lines));
      for (let i = 1; i < Math.min(got, giftIds.length); i += 1) {
        if (!giftIds[i] || has(i)) continue;
        const properties = {};
        $$(`[data-pick="${i}"]`).forEach((sel) => { properties[sel.dataset.prop] = sel.value || 'Verras me'; });
        out.push({ id: giftIds[i], quantity: 1, properties });
      }
    }
    return out;
  }
  root.pdpxItems = items; // the offer block below adds its lines through this, so the gifts come along
  const add = (btn, lines = [current()]) => {
    if (window.Scentzi && window.Scentzi.addItems) window.Scentzi.addItems(items(lines), btn);
    else $('[data-pdpx-form]').submit();
  };
  $('[data-pdpx-form]').addEventListener('submit', (e) => { e.preventDefault(); add($('[data-pdpx-buy]'), pending()); });
  const barBuy = $('[data-pdpx-bar-buy]');
  if (barBuy) barBuy.addEventListener('click', (e) => add(e.currentTarget, pending()));
  const syncCart = () => fetch(((window.Scentzi && window.Scentzi.routes && window.Scentzi.routes.cart) || '/cart') + '.js')
    .then((r) => r.json()).then((c) => {
      cartTotal = c.total_price;
      inCart = new Map();
      c.items.filter((i) => giftIds.includes(i.variant_id)).forEach((i) => inCart.set(i.variant_id, (inCart.get(i.variant_id) || 0) + i.quantity));
      render();
    }).catch(() => {});
  document.addEventListener('scentzi:cart', syncCart);
  syncCart();

  /* ---------- WELKOM10: copy the code ---------- */
  $$('[data-copy-code]').forEach((btn) => btn.addEventListener('click', async () => {
    const label = btn.querySelector('[data-copy-label]');
    try { await navigator.clipboard.writeText(btn.dataset.copyCode); if (label) label.textContent = 'gekopieerd ✓'; } catch (err) { if (label) label.textContent = 'selecteer en kopieer'; }
    setTimeout(() => { if (label) label.textContent = 'kopieer'; }, 2500);
  }));

  /* ---------- video cards: silent clips in a carousel that keeps moving ---------- */
  // The cards are cloned once so the track can loop seamlessly (CSS moves it by -50%); clones are hidden from
  // assistive tech. Clips play only while on screen. Reduced motion: no carousel, no autoplay, a plain row.
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  $$('[data-ugc-row]').forEach((row) => {
    if (calm) return;
    const cards = [...row.children];
    if (cards.length < 2) return;
    const track = document.createElement('div');
    track.className = 'pdpx-ugc-track';
    cards.forEach((c) => track.append(c));
    cards.forEach((c) => { const twin = c.cloneNode(true); twin.setAttribute('aria-hidden', 'true'); track.append(twin); });
    track.style.setProperty('--ugc-loop', `${cards.length * 4.5}s`);
    row.append(track);
    row.classList.add('is-moving');
    if (!('IntersectionObserver' in window)) { $$('video', row).forEach((v) => v.play().catch(() => {})); return; }
    const seen = new IntersectionObserver((entries) => entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) target.play().catch(() => {}); else target.pause();
    }), { threshold: 0.25 });
    $$('video', row).forEach((v) => seen.observe(v));
  });

  /* ---------- sticky bar once the buy button is off screen ---------- */
  const bar = $('[data-pdpx-bar]');
  const buy = $('[data-pdpx-buy]');
  if (bar && buy && 'IntersectionObserver' in window) {
    let below = false, footer = false;
    const sync = () => { bar.hidden = !below || footer || document.body.classList.contains('sz-locked'); };
    // Visible whenever the main button is off screen: above it (scrolled past) or still below it (phones).
    new IntersectionObserver(([e]) => { below = !e.isIntersecting; sync(); }).observe(buy);
    const foot = document.querySelector('.site-footer');
    if (foot) new IntersectionObserver(([e]) => { footer = e.isIntersecting; sync(); }).observe(foot);
  }

  /* ---------- expected delivery window: weekends and Dutch public holidays don't count ---------- */
  (function deliveryWindow() {
    const slots = $$('[data-pdpx-window]');
    const m = (root.dataset.deliveryDays || '').match(/(\d+)\D+(\d+)/);
    if (!m || !slots.length) return;
    const key = (d) => `${d.getMonth() + 1}-${d.getDate()}`;
    const holidays = (y) => {
      const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
        g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7, n = Math.floor((a + 11 * h + 22 * l) / 451),
        month = Math.floor((h + l - 7 * n + 114) / 31), day = ((h + l - 7 * n + 114) % 31) + 1;
      const easter = (x) => key(new Date(y, month - 1, day + x));
      return new Set(['1-1', new Date(y, 3, 27).getDay() === 0 ? '4-26' : '4-27', '12-25', '12-26', easter(1), easter(39), easter(50)]);
    };
    const addDays = (days) => {
      const now = new Date(), d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      for (let n = 0; n < days;) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w && w !== 6 && !holidays(d.getFullYear()).has(key(d))) n++; }
      return d;
    };
    const fmt = (d) => new Intl.DateTimeFormat('nl-NL', { weekday: 'short', day: 'numeric', month: 'short' }).format(d).replace(/\./g, '');
    const a = addDays(+m[1]), b = addDays(+m[2]), first = a.getMonth() === b.getMonth() ? fmt(a).replace(/ \S+$/, '') : fmt(a);
    slots.forEach((slot) => { slot.textContent = `${first} – ${fmt(b)}`; });
  })();

  /* ---------- scent pyramid: the line beside the cards fills up to the middle of the screen as you scroll ---------- */
  (function pyramid() {
    const steps = $('.pdpx-pyr-steps');
    const fill = $('[data-pyr-fill]');
    if (!steps || !fill) return;
    const cards = $$('[data-pyr-step]');
    let frame = 0;
    const update = () => {
      frame = 0;
      const box = steps.getBoundingClientRect();
      const reach = Math.max(0, Math.min(box.height, innerHeight * 0.55 - box.top));
      fill.style.height = `${reach}px`;
      cards.forEach((card) => {
        const dot = card.querySelector('.pdpx-pyr-dot').getBoundingClientRect();
        card.classList.toggle('is-on', dot.top + dot.height / 2 - box.top <= reach);
      });
    };
    addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, { passive: true });
    addEventListener('resize', update);
    update();
  })();

  /* ---------- "Lijkt op" tabs ---------- */
  $$('[data-more-tab]').forEach((tab) => tab.addEventListener('click', () => {
    $$('[data-more-tab]').forEach((t) => t.setAttribute('aria-selected', t === tab));
    $$('.pdpx-more-panel').forEach((panel, i) => { panel.hidden = i !== +tab.dataset.moreTab; });
  }));

  const initial = new URL(location.href).searchParams.get('variant');
  if (initial) { const r = $(`.pdpx-size input[data-variant="${initial}"]`); if (r && !r.checked) selectSize(r); }
  const opened = sizeRadio();
  if (opened && opened.dataset.shot && shot && shot.hidden) { showShot(opened.dataset.shot); shownAt = 0; }
  render();
  if ('requestIdleCallback' in window) requestIdleCallback(() => loadCatalogue()); else setTimeout(loadCatalogue, 2000);
})();

/* Offer block: bottle + refill + the chosen etui in one go. In the time-limited deal the etui turns free through the
   automatic discount; the gift set adds the gift bag too and shows its total for the chosen etui. */
(() => {
  const btn = document.querySelector('[data-deal-add]');
  if (!btn) return;
  const box = btn.closest('.pdpx-offer');
  const etui = box.querySelector('[data-deal-etui]');
  const total = box.querySelector('[data-offer-total]');
  const showTotal = () => {
    const o = etui && etui.selectedOptions[0];
    const cents = +box.dataset.offerBase + (o ? +o.dataset.price || 0 : 0);
    total.textContent = window.Scentzi && window.Scentzi.money ? window.Scentzi.money(cents) : `€ ${(cents / 100).toFixed(2).replace('.', ',')}`;
  };
  if (total && box.dataset.offerBase) { showTotal(); if (etui) etui.addEventListener('change', showTotal); }
  btn.addEventListener('click', () => {
    // A deal etui has no price here: the discount makes it free, so it doesn't count towards the gift tiers.
    const lines = [{ id: +btn.dataset.bottle, price: +btn.dataset.bottlePrice }, { id: +btn.dataset.refill, price: +btn.dataset.refillPrice }];
    const o = etui && etui.selectedOptions[0];
    if (o && o.value) lines.push({ id: +o.value, price: +o.dataset.price || 0 });
    if (btn.dataset.extra) lines.push({ id: +btn.dataset.extra, price: +btn.dataset.extraPrice });
    const pdpx = document.querySelector('[data-pdpx]');
    const items = pdpx && pdpx.pdpxItems ? pdpx.pdpxItems(lines) : lines.map((l) => ({ id: l.id, quantity: 1 }));
    if (window.Scentzi && window.Scentzi.addItems) window.Scentzi.addItems(items, btn);
  });
})();
